import actions from "./actions";

const initState = {
  result: null,
  loading: false,
  errorMessage: null,
};

export default function createOrUpdateInsuranceCompanyReducer(
  state = initState,
  action
) {
  switch (action.type) {
    case actions.CREATE_OR_UPDATE_INSURANCE_COMPANY_REQUESTED:
      return {
        ...state,
        result: null,
        loading: true,
        errorMessage: null,
      };
    case actions.CREATE_OR_UPDATE_INSURANCE_COMPANY_SUCCEEDED:
      return {
        ...state,
        result: action.payload,
        loading: false,
      };
    case actions.CREATE_OR_UPDATE_INSURANCE_COMPANY_FAILED:
      return {
        ...state,
        loading: false,
        errorMessage: action.error,
      };
    default:
      return state;
  }
}
